import React, { Component, Fragment } from "react";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import {
  change_Lang,
  EveryTimeTo_English,
} from "../../../actions/Helper_action";
import { Create_Rent_MainForm } from "../../../actions_agent/Invoice_action";
import { Tabs } from "react-tabs";
import Breadcrumb from "../../../components/common/breadcrumb";
import { Divider, Input, Popover, Select } from "antd";
import PropertyesList from "../../Propertys_Agent/PropertyesList";
import { FaInfoCircle } from "react-icons/fa";
export class SecondaryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      introduction: 0,
      firstname: "",
      secondname: "",
      duedate: "",
      paymentmonth: "",
      fee: 0,
      startdate: "",
      enddate: "",
      feelate: 0,
      save: null,
      rental: "",
      perpose: "",
      safly: 0,
      phone2: "",
      phone1: 0,
      forRE: 0,
      currency: "dolar",
      Place_ku: "",
      NOoFProperty: "",
      Property: "",
      Area: "",
      Monthintroduction: 0,
      MonthForRent: 0,
      note: "",
      payCompany: 0,
      block: "",
      flour: "",
      metrPrice: "",
      witness1: "",
      witness2: "",
      isBalance: "",
      status: "active",
      redirect: false,
      article_8: "",
      article_9: "",
      article_10: "",
      article_8_ar: "",
      article_9_ar: "",
      article_10_ar: "",
    };
  }
  New_Page_Rent = () => {
    this.setState({
      introduction: 0,
      firstname: "",
      secondname: "",
      duedate: "",
      paymentmonth: "",
      fee: 0,
      startdate: "",
      enddate: "",
      feelate: 0,
      save: null,
      rental: "",
      perpose: "",
      safly: 0,
      phone2: "",
      phone1: 0,
      forRE: 0,
      currency: "",
      Place_ku: "",
      NOoFProperty: "",
      Property: "",
      Area: "",
      Monthintroduction: 0,
      MonthForRent: 0,
      note: "",
      payCompany: 0,
      block: "",
      flour: "",
      metrPrice: "",
      witness1: "",
      witness2: "",
      isBalance: "",
      status: "active",
      redirect: false,
      article_8: "",
      article_9: "",
      article_10: "",
      article_8_ar: "",
      article_9_ar: "",
      article_10_ar: "",
    });
  };

  onCreating_Take_Money = () => {
    var curr = new Date();
    curr.setDate(curr.getDate());
    let today = curr.toISOString().substr(0, 10);
    const data = {
      firstname: this.state.firstname,
      secondname: this.state.secondname,
      introduction:
        this.state.introduction !== ""
          ? parseFloat(this.state.introduction.toString().replace(/,/g, ""))
          : 0,
      duedate: this.state.duedate !== "" ? this.state.duedate : today,
      perpose: this.state.perpose,
      fee:
        this.state.fee !== ""
          ? parseFloat(this.state.fee.toString().replace(/,/g, ""))
          : 0,
      rental: this.state.rental !== "" ? this.state.rental : 1,
      payCompany:
        this.state.payCompany !== ""
          ? parseFloat(this.state.payCompany.toString().replace(/,/g, ""))
          : 0,
      paymentmonth:
        this.state.paymentmonth !== ""
          ? parseFloat(this.state.paymentmonth.toString().replace(/,/g, ""))
          : 0,
      safly:
        this.state.safly !== ""
          ? parseFloat(this.state.safly.toString().replace(/,/g, ""))
          : 0,
      feelate:
        this.state.feelate !== ""
          ? parseFloat(this.state.feelate.toString().replace(/,/g, ""))
          : 0,
      startdate: this.state.startdate !== "" ? this.state.startdate : today,
      enddate: this.state.enddate !== "" ? this.state.enddate : today,
      currency: this.props.EveryTimeTo_English(this.state.currency),
      phone2: this.state.phone2 !== "" ? this.state.phone2 : 0,
      phone1: this.state.phone1 !== "" ? this.state.phone1 : 0,
      Place_ku: this.state.Place_ku,
      NOoFProperty: this.state.NOoFProperty,
      Property: this.state.Property,
      Area: this.state.Area,
      MonthForRent: this.state.MonthForRent,
      Monthintroduction: this.state.Monthintroduction,
      note: this.state.note,
      block: this.state.block,
      flour: this.state.flour,
      metrPrice: this.state.metrPrice,
      witness1: this.state.witness1,
      witness2: this.state.witness2,
      isBalance: this.state.isBalance,
      status: this.state.status,
      article_8: this.state.article_8,
      article_9: this.state.article_9,
      article_10: this.state.article_10,
      article_8_ar: this.state.article_8_ar,
      article_9_ar: this.state.article_9_ar,
      article_10_ar: this.state.article_10_ar,
    };
    if (
      this.state.firstname === "" ||
      this.state.secondname === "" ||
      this.state.paymentmonth === "" ||
      this.state.paymentmonth === 0 ||
      this.state.currency.toString().length === 0 ||
      this.state.rental === "" ||
      this.state.Property.toString().length === 0
    ) {
      Swal.fire({
        title: "OPS",
        text: this.props.change_Lang("Please Check Inputs"),
        icon: "error",
        html: `<b class="fk">${this.props.change_Lang(
          "Please Check Inputs"
        )}</b>`,
        confirmButtonText: this.props.change_Lang("Ok"),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1300,
      });
    } else {
      this.props.Create_Rent_MainForm(data);
      Swal.fire({
        title: "Good job!",
        html: `<b class="fk">${this.props.change_Lang(
          "You successfully tainted your work"
        )}</b>`,
        icon: "success",
        confirmButtonText: this.props.change_Lang("success"),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1000,
      });
      this.setState({
        save: true,
        redirect: true,
      });
    }
  };
  handleChange_Property = (value) => {
    this.setState({ Property: value });
  };
  OnChangeHandler = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleKeyDown = (event) => {
    if (event.key === "-" || event.key === "e" || event.key === "ArrowDown") {
      event.preventDefault();
    }
  };
  handleChange_currency = (value) => {
    this.setState({ currency: value });
  };
  handleChange_Property = (value) => {
    this.setState({ Property: value });
  };
  handleChange_Status = (value) => {
    this.setState({ status: value });
  };
  render() {
    const { change_Lang, lang, user } = this.props;
    const {
      OnChangeHandler,
      handleChange_Property,
      handleKeyDown,
      handleChange_Status,
    } = this;
    const {
      introduction,
      firstname,
      secondname,
      duedate,
      paymentmonth,
      fee,
      startdate,
      enddate,
      rental,
      perpose,
      safly,
      phone2,
      phone1,
      Place_ku,
      NOoFProperty,
      Property,
      Monthintroduction,
      MonthForRent,
      Area,
      feelate,
      note,
      block,
      flour,
      isBalance,
      status,
      redirect,
      article_9,
      article_10,
      article_8,
      article_10_ar,
      article_8_ar,
      article_9_ar,
    } = this.state;

    const { Option } = Select;
    let curr = new Date();
    curr.setDate(curr.getDate());
    let today = curr.toISOString().substr(0, 10);
    const selectBefore = (
      <Select
        defaultValue="dolar"
        onChange={this.handleChange_currency}
        className="select-before"
      >
        <Option value="dolar">{change_Lang("dolar")}</Option>
        <Option value="dinar">{change_Lang("dinar")}</Option>
      </Select>
    );
    if (redirect) {
      if (status !== "Rejected") {
        return <Redirect to="/List_Rent_Invoices" />;
      } else {
        return <Redirect to="/List_Rent_Invoices_fast" />;
      }
    } else {
      return (
        <Fragment>
          <Breadcrumb
            title={change_Lang("Rent_Contracts")}
            parent={change_Lang("s_dashboard")}
          />
          <Tabs>
            <div
              className={`${
                lang === "en" ? "container-fluid" : "container-fluid fk"
              }`}
            >
              <div
                className="card product-page-main card-body"
                style={{ background: "#e3e9f2 " }}
              >
                <div className="row">
                  <div
                    className="col-sm-3 d-flex justify-content-center"
                    style={{
                      background: "white",
                      borderRadius: "10px",
                    }}
                  >
                    <Link to="/Secondary_Form">
                      <label
                        style={{
                          fontWeight: "bolder",
                          fontSize: "16px",
                          color: "#4064d7",
                          marginTop: "5px",
                          cursor: "pointer",
                        }}
                        className=" d-flex justify-content-start "
                      >
                        {change_Lang("Secondary Form")}
                      </label>
                    </Link>
                    &nbsp;&nbsp;
                    <Link to="/Main_Form">
                      <label
                        style={{
                          fontSize: "16px",
                          color: "#052f43",
                          marginTop: "5px",

                          cursor: "pointer",
                        }}
                        className=" d-flex justify-content-end"
                      >
                        {change_Lang("Main Form")}
                      </label>
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <div
                    className="row d-flex justify-content-center"
                    style={{
                      background: "white",
                      borderRadius: "10px",
                    }}
                  >
                    <div className="col-sm-12 d-flex justify-content-center">
                      <label
                        style={{
                          fontWeight: "bolder",
                          fontSize: "18px",
                          color: "#052f43",
                          margin: "5px 0px 3px 0px",
                        }}
                      >
                        {change_Lang("Rental contract")}
                      </label>
                    </div>
                  </div>
                  <br />
                  <div className="row mb-4 ">
                    <div className="col-sm-6">
                      <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "13px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-center ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("First side (property owner)")}:
                          </label>
                        </div>
                        <div className="col-sm-8">
                          <Input
                            type="text"
                            value={firstname}
                            onChange={OnChangeHandler}
                            name="firstname"
                            autoComplete="off"
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            style={{
                              fontSize: "16px",
                              textAlign: "center",
                            }}
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "ناوی  خاوەن موڵك داخل بکە بەم شێوەیە "
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : محمد عبداللە عمر
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("phone_number")}:
                          </label>
                        </div>
                        <div className="col-sm-8">
                          <Input
                            type="number"
                            min={1}
                            step={1}
                            value={phone1 === 0 ? "" : phone1}
                            onChange={OnChangeHandler}
                            name="phone1"
                            onKeyDown={handleKeyDown}
                            autoComplete="off"
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            style={{
                              fontSize: "16px",
                            }}
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "ژمارەی مۆبایلی خاوەن موڵك داخل بکە بەم شێوەیە "
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : 07501002020
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits mt-2 form-group row ">
                        <div className="col-sm-4 ">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("Type of property")}:
                          </label>
                        </div>
                        <div className="col-sm-8 ">
                          <PropertyesList
                            onChangeProperty={handleChange_Property}
                            valueOption={Property}
                            size="large"
                          />
                        </div>
                      </div>
                      {Property !== "Apartment" ? (
                        ""
                      ) : (
                        <div className="product-price digits mt-2 form-group row">
                          <div className="col-sm-4">
                            <label
                              style={{
                                fontSize: "16px",
                                color: "#052f43",
                                fontWeight: "bold",
                              }}
                              className={`d-flex justify-content-start ${
                                lang === "en"
                                  ? "col-form-label"
                                  : "col-form-label fk"
                              }`}
                            >
                              {change_Lang("block")}:
                            </label>
                          </div>
                          <div
                            className={`${
                              lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                            }`}
                          >
                            <Input
                              className={`${
                                lang === "en"
                                  ? "form-control text-center"
                                  : "form-control text-center fk"
                              }`}
                              onChange={OnChangeHandler}
                              type="text"
                              value={block}
                              name="block"
                              style={{
                                fontSize: "16px",
                              }}
                              autoComplete="off"
                              addonBefore={
                                <>
                                  <Popover
                                    content={
                                      <div className="text-center">
                                        <span
                                          className="fk"
                                          style={{ fontSize: "14px" }}
                                        >
                                          {
                                            "باڵەخەنەی شووقەکە داخڵ بکە بەم شێوەیە"
                                          }
                                        </span>
                                        <br />
                                        <span className="text-center">
                                          نمونە : A
                                        </span>
                                      </div>
                                    }
                                  >
                                    <span className=" py-0 px-0">
                                      <i className="fas fa-info-circle"></i>
                                    </span>
                                  </Popover>
                                </>
                              }
                            />
                          </div>
                        </div>
                      )}
                      <div className="product-price digits mt-2 form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {Property !== "Apartment"
                              ? change_Lang("Number of property")
                              : change_Lang("NumberOfShuqa")}
                            :
                          </label>
                        </div>
                        <div
                          className={`${
                            lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                          }`}
                        >
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            onChange={OnChangeHandler}
                            type="text"
                            value={NOoFProperty}
                            name="NOoFProperty"
                            style={{
                              fontSize: "16px",
                            }}
                            autoComplete="off"
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {"ژمارەی موڵکەکە داخل بکە بەم شێوەیە "}
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : 12/15/250 یان 1
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits mt-2 form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("On the date of")}:
                          </label>
                        </div>
                        <div
                          className={`${
                            lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                          }`}
                        >
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            onChange={OnChangeHandler}
                            type="date"
                            pattern="dd-mm-yyyy"
                            min="1997-01-01"
                            max="2030-12-31"
                            value={startdate ? startdate : today}
                            name="startdate"
                            style={{
                              fontSize: "16px",
                            }}
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "بەرواری دەست پێکردنی کرێ داخل بکە بە شیوەی ساڵ/ڕۆژ/مانگ "
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە: 1/2/2022 ژمارە یەک مانگە ژمارە 2
                                        ڕۆژە
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits mt-2 form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("tr_amount")}:
                          </label>
                        </div>
                        <div
                          className={`${
                            lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                          }`}
                        >
                          <Input
                            size="large"
                            type={"number"}
                            name="paymentmonth"
                            onChange={OnChangeHandler}
                            onKeyDown={handleKeyDown}
                            value={paymentmonth === 0 ? "" : paymentmonth}
                            required
                            min={1}
                            step={1}
                            addonBefore={selectBefore}
                            autoComplete="off"
                            className="text-center"
                            prefix={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "ئەو بڕە پارەییەی مانگانە لەسەری رێککەوتوون داخلی بکە"
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : 300
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      {/* is balance off */}
                      <div className="product-price digits mt-2 form-group row ">
                        <div className="col-sm-4 ">
                          <label
                            style={{
                              fontSize: "14px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("Will the balance be made?")}:
                          </label>
                        </div>
                        <div className="col-sm-8 ">
                          <select
                            value={isBalance}
                            onChange={OnChangeHandler}
                            name="isBalance"
                            className="custom-select form-control text-center fk"
                            required
                            style={{ fontWeight: "bold", fontSize: "16px" }}
                          >
                            <option
                              style={{ fontWeight: "bold", fontSize: "16px" }}
                              value=""
                            >
                              --{change_Lang("Choose")}--
                            </option>
                            <option
                              style={{ fontWeight: "bold", fontSize: "16px" }}
                              value={"on"}
                            >
                              {change_Lang("Yes")}
                            </option>
                            <option
                              style={{ fontWeight: "bold", fontSize: "16px" }}
                              value={"off"}
                            >
                              {change_Lang("No")}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="product-price digits mt-2 form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("amount of money in advance")}:
                          </label>
                        </div>
                        <div
                          className={`${
                            lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                          }`}
                        >
                          {/* <NumberFormat
                            style={{
                              fontSize: "16px",
                            }}
                            placeholder={change_Lang("note_6")}
                            displayType="input"
                            thousandSeparator={true}
                            name="introduction"
                            onChange={OnChangeHandler}
                            value={introduction === 0 ? "" : introduction}
                            required
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            autoComplete="off"
                          /> */}
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            onChange={OnChangeHandler}
                            type="number"
                            min={1}
                            step={1}
                            onKeyDown={handleKeyDown}
                            value={introduction === 0 ? "" : introduction}
                            name="introduction"
                            style={{
                              fontSize: "16px",
                            }}
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "بڕی ئەو پارە داخڵ بکە کە کرێجیەکە دەیدا بە خاوەن موڵک وەک و پێشەکی ئایا مانگێکە یان زیاترە"
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : 900 واتا کرێ سێ مانگی داوە.
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits mt-2 form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("as introduction for Month")}:
                          </label>
                        </div>
                        <div
                          className={`${
                            lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                          }`}
                        >
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            onChange={OnChangeHandler}
                            type="number"
                            min={1}
                            step={1}
                            onKeyDown={handleKeyDown}
                            value={
                              Monthintroduction === 0 ? "" : Monthintroduction
                            }
                            name="Monthintroduction"
                            style={{
                              fontSize: "16px",
                            }}
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "ژمارەی ئە مانگانە بنووسە کە وەک پێشەکی پارەی دراوە ئینجا ئایا مانگێکە یان زیاتر"
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : 1 یاخود 3
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits mt-2 form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("Rental period")}:
                          </label>
                        </div>
                        <div
                          className={`${
                            lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                          }`}
                        >
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            onChange={OnChangeHandler}
                            type="number"
                            min={1}
                            step={1}
                            onKeyDown={handleKeyDown}
                            value={rental === 0 ? "" : rental}
                            name="rental"
                            style={{
                              fontSize: "16px",
                            }}
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "ژمارەی ئەو مانگانە بنووسە کە موڵکەکە بۆ کرێ ڕێکەوتنی لەسەر کراوە بۆ نمونە ئەگەر بۆ ساڵێک بوو بنووسە 12 واتا 12 مانگ "
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : 12
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("type of contract")}:
                          </label>
                        </div>
                        <div
                          className={`${
                            lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                          }`}
                        >
                          <Select
                            onChange={handleChange_Status}
                            value={status}
                            defaultValue={change_Lang("Choose")}
                            className="fk col-12 text-center"
                            showArrow={false}
                            size="large"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#4064d7",
                            }}
                          >
                            <Option value="" className="fk">
                              {change_Lang("Choose")}
                            </Option>
                            <Option className="fk" value={"active"}>
                              {change_Lang("active")}
                            </Option>
                            <Option className="fk" value={"Rejected"}>
                              {change_Lang("Rejected")}
                            </Option>
                          </Select>
                        </div>
                      </div>
                      <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("note")}:
                          </label>
                        </div>
                        <div
                          className={`${
                            lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                          }`}
                        >
                          <Input
                            className="form-control"
                            onChange={OnChangeHandler}
                            type="text"
                            value={note}
                            name="note"
                            style={{
                              fontSize: "16px",
                            }}
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "هەر تێبینیەکت هەبوو لێرە بینووسە لە خوارەوەی گریبەستەکەت دەردەکەوێ"
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center"></span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <br />
                    </div>
                    <div className="col-sm-6 mt-2">
                      <div className="product-price digits form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("Second side (tenant)")}:
                          </label>
                        </div>
                        <div
                          className="col-sm-8"
                          style={{
                            fontSize: "16px",
                          }}
                        >
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            onChange={OnChangeHandler}
                            type="text"
                            value={secondname}
                            name="secondname"
                            style={{
                              fontSize: "16px",
                            }}
                            autoComplete="off"
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {"ناوی کرێچی داخل بکە بەم شێوەیە "}
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        محمد عبداللە عمر
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits  form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("invoice_mob_tenat")}:
                          </label>
                        </div>
                        <div className="col-sm-8">
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            onChange={OnChangeHandler}
                            type="number"
                            min={1}
                            step={1}
                            onKeyDown={handleKeyDown}
                            value={phone2 === 0 ? "" : phone2}
                            name="phone2"
                            style={{
                              fontSize: "16px",
                            }}
                            autoComplete="off"
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "ژمارەی مۆبایلی کرێچی داخل بکە بەم شێوەیە "
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        07501002020
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("Area")}:
                          </label>
                        </div>
                        <div className="col-sm-8">
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            onChange={OnChangeHandler}
                            type="number"
                            min={1}
                            step={1}
                            onKeyDown={handleKeyDown}
                            value={Area}
                            name="Area"
                            style={{
                              fontSize: "16px",
                            }}
                            autoComplete="off"
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "ڕووبەری موڵکەکە داخل بکە بەم شێوەیە ئاگەدار بە تەنها ژمارە داخڵ بکە"
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : 200
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      {Property !== "Apartment" ? (
                        ""
                      ) : (
                        <div className="product-price digits mt-2 form-group row">
                          <div className="col-sm-4">
                            <label
                              style={{
                                fontSize: "16px",
                                color: "#052f43",
                              }}
                              className={`d-flex justify-content-start ${
                                lang === "en"
                                  ? "col-form-label"
                                  : "col-form-label fk"
                              }`}
                            >
                              {change_Lang("flour")}:
                            </label>
                          </div>
                          <div
                            className={`${
                              lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                            }`}
                          >
                            <Input
                              className={`${
                                lang === "en"
                                  ? "form-control text-center"
                                  : "form-control text-center fk"
                              }`}
                              onChange={OnChangeHandler}
                              type="text"
                              onKeyDown={handleKeyDown}
                              value={flour}
                              name="flour"
                              style={{
                                fontSize: "16px",
                              }}
                              autoComplete="off"
                              addonBefore={
                                <>
                                  <Popover
                                    content={
                                      <div className="text-center">
                                        <span
                                          className="fk"
                                          style={{ fontSize: "14px" }}
                                        >
                                          {"قاتی شوقەکە داخڵ بکە "}
                                        </span>
                                        <br />
                                        <span className="text-center">
                                          نمونە : 12
                                        </span>
                                      </div>
                                    }
                                  >
                                    <span className=" py-0 px-0">
                                      <i className="fas fa-info-circle"></i>
                                    </span>
                                  </Popover>
                                </>
                              }
                            />
                          </div>
                        </div>
                      )}
                      <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("profile_location")}:
                          </label>
                        </div>
                        <div className="col-sm-8 ">
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            style={{
                              color: "black",
                              borderRadius: "5px",
                            }}
                            value={Place_ku}
                            onChange={OnChangeHandler}
                            name="Place_ku"
                            type="text"
                            autoComplete="off"
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {"شوێنی موڵکەکە داخل بکە بەم شێوەیە "}
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : ستار تاوەر
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("For a date")}:
                          </label>
                        </div>
                        <div className="col-sm-8 ">
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            style={{
                              color: "black",
                              borderRadius: "5px",
                            }}
                            value={enddate ? enddate : today}
                            onChange={OnChangeHandler}
                            name="enddate"
                            type="date"
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "بەرواری تەواوبوونی کرێ داخل بکە بە شیوەی ساڵ/ڕۆژ/مانگ "
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە: 1/2/2023 ژمارە یەک مانگە ژمارە 2
                                        ڕۆژە
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits d-flex justify-content-start form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("for purposes")}:
                          </label>
                        </div>
                        <div className="col-sm-8 ">
                          {Property !== "Apartment" && Property !== "House" ? (
                            <Input
                              style={{
                                color: "black",
                                borderRadius: "5px",
                              }}
                              value={perpose}
                              onChange={OnChangeHandler}
                              name="perpose"
                              type="text"
                              className={`${
                                lang === "en"
                                  ? "form-control text-center"
                                  : "form-control text-center fk"
                              }`}
                              addonBefore={
                                <>
                                  <Popover
                                    content={
                                      <div className="text-center">
                                        <span
                                          className="fk"
                                          style={{ fontSize: "14px" }}
                                        >
                                          {
                                            "مەبەستی موڵکەکە داخل بکە کە بۆ چ مەبەستێک بەکاردێ بەم شێوەیە "
                                          }
                                        </span>
                                        <br />
                                        <span className="text-center">
                                          نمونە : نیشتەجێبوون
                                        </span>
                                      </div>
                                    }
                                  >
                                    <span className=" py-0 px-0">
                                      <i className="fas fa-info-circle"></i>
                                    </span>
                                  </Popover>
                                </>
                              }
                            />
                          ) : (
                            <select
                              value={perpose}
                              onChange={OnChangeHandler}
                              name="perpose"
                              className="form-control text-center fk"
                              required
                              style={{ fontWeight: "bold", fontSize: "16px" }}
                            >
                              <option
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                                value=""
                              >
                                --{change_Lang("Choose")}--
                              </option>
                              <option
                                value={"Housing"}
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                              >
                                {change_Lang("Housing")}
                              </option>
                              <option
                                style={{ fontWeight: "bold", fontSize: "16px" }}
                                value={"office"}
                              >
                                {change_Lang("office")}
                              </option>
                            </select>
                          )}
                          {/* brwa */}
                        </div>
                      </div>

                      <div className="product-price digits  d-flex justify-content-start form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "14px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("Amount of punishment")}:
                          </label>
                        </div>
                        <div className="col-sm-8 ">
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            style={{
                              color: "black",
                              borderRadius: "5px",
                            }}
                            name="fee"
                            onChange={OnChangeHandler}
                            value={fee === 0 ? "" : fee}
                            type="number"
                            min={1}
                            step={1}
                            onKeyDown={handleKeyDown}
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        ئەگەر لایەنی یەکەم لە ڕێکەوتی
                                        دیاریکراودا ئە موڵکە ڕادەستی لایەنی
                                        دووەم(کرێچی)نەکرد
                                        <br />
                                        ئەوا دەبێ پابەند بێ بەپێدانی پارە بە
                                        لایەنی دووەم بۆ هەر ڕۆژێک
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : 20
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "14px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("once a month in advance")}:
                          </label>
                        </div>
                        <div className="col-sm-8 ">
                          <Input
                            style={{
                              fontSize: "16px",
                            }}
                            type="number"
                            min={1}
                            step={1}
                            onKeyDown={handleKeyDown}
                            name="MonthForRent"
                            onChange={OnChangeHandler}
                            value={MonthForRent === 0 ? "" : MonthForRent}
                            required
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            autoComplete="off"
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "لایەنی دووەم پابەندە بە پێدانی کرێیەکە چەندمانگ جارێک پێشەکی بۆ نمونە 2 مانگ جارێک کرێ دەدرێت تەنها ژمارە داخڵ بکە "
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : 2
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "14px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("Date of surrender")}:
                          </label>
                        </div>
                        <div className="col-sm-8 ">
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            style={{
                              color: "black",
                              borderRadius: "5px",
                            }}
                            value={duedate ? duedate : today}
                            onChange={OnChangeHandler}
                            name="duedate"
                            type="date"
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "ئەگەر لایەنی دووەم تاوەکو بەرواری (00/00/0000) نەیتوانی رێپدان لە لایەنی پەیوەندار وەربگرێ لەم بارەدا راستەخۆ گرێبەستەکە هەلدەوەشێتەوە ئەو بڕە کرێیەش کە دراوە دەگەڕێندرێتەوە لایەنی دووەم."
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : مانگ/ڕۆژ/ساڵ
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits mt-2 form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "14px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("Punishment after five days")}:
                          </label>
                        </div>
                        <div
                          className={`${
                            lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                          }`}
                        >
                          <Input
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            style={{
                              color: "black",
                              borderRadius: "5px",
                            }}
                            value={feelate === 0 ? "" : feelate}
                            name="feelate"
                            onChange={OnChangeHandler}
                            type="number"
                            min={1}
                            step={1}
                            onKeyDown={handleKeyDown}
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        دوای تەواو بونی ماوەی ئەم گرێبەستە ئەگەر
                                        لایەنی دووەم پابەند نەبێ بە چۆڵکردن
                                        <br /> یان نوێکردنەوەی ئەم گرێبەستە ئەوا
                                        کرێی موڵکەکە دەبێت بە رۆژانە بە برێ ____
                                        بداتە لایەنی یەکەم
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : 20
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                      <div className="product-price digits mt-2 form-group row">
                        <div className="col-sm-4">
                          <label
                            style={{
                              fontSize: "16px",
                              color: "#052f43",
                              fontWeight: "bold",
                            }}
                            className={`d-flex justify-content-start ${
                              lang === "en"
                                ? "col-form-label"
                                : "col-form-label fk"
                            }`}
                          >
                            {change_Lang("such as Assurances")}:
                          </label>
                        </div>
                        <div
                          className={`${
                            lang === "en" ? "col-sm-8" : "col-sm-8 fk"
                          }`}
                        >
                          <Input
                            style={{
                              fontSize: "16px",
                            }}
                            type="number"
                            min={1}
                            step={1}
                            onKeyDown={handleKeyDown}
                            value={safly === 0 ? "" : safly}
                            name="safly"
                            onChange={OnChangeHandler}
                            className={`${
                              lang === "en"
                                ? "form-control text-center"
                                : "form-control text-center fk"
                            }`}
                            autoComplete="off"
                            addonBefore={
                              <>
                                <Popover
                                  content={
                                    <div className="text-center">
                                      <span
                                        className="fk"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {
                                          "بڕی پارەی دڵنیایی داخڵ بکە بەم شێوەیە"
                                        }
                                      </span>
                                      <br />
                                      <span className="text-center">
                                        نمونە : 500
                                      </span>
                                    </div>
                                  }
                                >
                                  <FaInfoCircle
                                    style={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                      display: "flex",
                                      color: "#000",
                                      fontWeight: "bolder",
                                    }}
                                    size={15}
                                  />
                                </Popover>
                              </>
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <Divider className="fk" plain>
                    زیادکردنی خاڵ (کوردی)
                  </Divider>
                  <div className="row">
                    <div className="col-md-12">
                      {" "}
                      <Input
                        className="form-control"
                        onChange={OnChangeHandler}
                        type="text"
                        value={article_8}
                        name="article_8"
                        style={{
                          fontSize: "15px",

                          borderBottomColor: "#3889c1",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"خاڵی 20"}
                                  </span>
                                  <br />
                                  <span className="text-center"></span>
                                </div>
                              }
                            >
                              <span
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              >
                                20
                              </span>
                            </Popover>
                          </>
                        }
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      {" "}
                      <Input
                        className="form-control"
                        onChange={OnChangeHandler}
                        type="text"
                        value={article_9}
                        name="article_9"
                        style={{
                          fontSize: "15px",

                          borderBottomColor: "#3889c1",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"خاڵی 21"}
                                  </span>
                                  <br />
                                  <span className="text-center"></span>
                                </div>
                              }
                            >
                              <span
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              >
                                21
                              </span>
                            </Popover>
                          </>
                        }
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      {" "}
                      <Input
                        className="form-control"
                        onChange={OnChangeHandler}
                        type="text"
                        value={article_10}
                        name="article_10"
                        style={{
                          fontSize: "15px",

                          borderBottomColor: "#3889c1",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"خاڵی 22"}
                                  </span>
                                  <br />
                                  <span className="text-center"></span>
                                </div>
                              }
                            >
                              <span
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              >
                                22
                              </span>
                            </Popover>
                          </>
                        }
                      />
                    </div>
                  </div>
                  <Divider className="fk" plain>
                    زیادکردنی خاڵ (عرەبی)
                  </Divider>
                  <div className="row">
                    <div className="col-md-12">
                      {" "}
                      <Input
                        className="form-control"
                        onChange={OnChangeHandler}
                        type="text"
                        value={article_8_ar}
                        name="article_8_ar"
                        style={{
                          fontSize: "15px",

                          borderBottomColor: "#3889c1",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"1خاڵی 9"}
                                  </span>
                                  <br />
                                  <span className="text-center"></span>
                                </div>
                              }
                            >
                              <span
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              >
                                19
                              </span>
                            </Popover>
                          </>
                        }
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      {" "}
                      <Input
                        className="form-control"
                        onChange={OnChangeHandler}
                        type="text"
                        value={article_9_ar}
                        name="article_9_ar"
                        style={{
                          fontSize: "15px",

                          borderBottomColor: "#3889c1",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"خاڵی 20"}
                                  </span>
                                  <br />
                                  <span className="text-center"></span>
                                </div>
                              }
                            >
                              <span
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              >
                                20
                              </span>
                            </Popover>
                          </>
                        }
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      {" "}
                      <Input
                        className="form-control"
                        onChange={OnChangeHandler}
                        type="text"
                        value={article_10_ar}
                        name="article_10_ar"
                        style={{
                          fontSize: "15px",

                          borderBottomColor: "#3889c1",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"خاڵی 21"}
                                  </span>
                                  <br />
                                  <span className="text-center"></span>
                                </div>
                              }
                            >
                              <span
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              >
                                21
                              </span>
                            </Popover>
                          </>
                        }
                      />
                    </div>
                  </div>
                  <br />
                  {user && user.c_contract !== false ? (
                    <div className="row">
                      <div className="col-12 d-flex justify-content-center">
                        <button
                          className="btn"
                          style={{ background: "#4350d8" }}
                          onClick={() => {
                            this.onCreating_Take_Money();
                          }}
                        >
                          <span
                            className="d-none d-lg-inline"
                            style={{ color: "white", fontSize: "12px" }}
                          >
                            {change_Lang("save")} &nbsp;&nbsp;&nbsp;
                          </span>
                          <i
                            className="far fa-save"
                            style={{ fontSize: "18px", color: "white" }}
                          ></i>
                        </button>
                        <button
                          className="btn mx-5"
                          style={{ background: "#7F8C8D" }}
                          onClick={this.New_Page_Rent}
                        >
                          <span
                            className="d-none d-lg-inline"
                            style={{ color: "white", fontSize: "12px" }}
                          >
                            {" "}
                            {change_Lang("new_page")}&nbsp;&nbsp;&nbsp;
                          </span>{" "}
                          <i
                            className="fas fa-file"
                            style={{ color: "white", fontSize: "18px" }}
                          ></i>
                        </button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </Tabs>
        </Fragment>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.HelperReducer.lang,
    rent_contracts: state.InvoiceReducer.rent_contracts,
    user: state.AuthReducer.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    change_Lang: (key) => dispatch(change_Lang(key)),
    EveryTimeTo_English: (keys) => dispatch(EveryTimeTo_English(keys)),
    Create_Rent_MainForm: (data) => dispatch(Create_Rent_MainForm(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryForm);
